"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const quiz_1 = require("../../network/quiz");
const use_lazy_promise_1 = require("../../hook/use-lazy-promise");
const quiz_renderer_1 = require("./quiz-renderer");
const alert_context_1 = require("../../context/alert-context");
const material_1 = require("@mui/material");
const answer_1 = require("./model/answer");
const button_1 = require("../../component/input/button");
const log_1 = require("../../model/log");
const QuizContainerInner = (0, react_1.memo)(({ passageId, questions, initialIndex = 0, userAnswers, onComplete, skipEnabled, }) => {
    const theme = (0, material_1.useTheme)();
    const { execute: executeUpdateAnswers, error: updateAnswersError, status: updateAnswersStatus, } = (0, use_lazy_promise_1.useLazyPromise)(quiz_1.updateAnswers);
    const [updatedAnswers, setUpdatedAnswers] = (0, react_1.useState)(new Map());
    const alert = (0, alert_context_1.useAlert)();
    const mergedAnswers = (0, react_1.useMemo)(() => {
        const result = new Map(userAnswers);
        updatedAnswers.forEach((answer, questionId) => {
            result.set(questionId, {
                answer,
                state: answer_1.AnswerResultState.Unknown,
            });
        });
        return result;
    }, [updatedAnswers, userAnswers]);
    const handleSubmit = (0, react_1.useCallback)(() => {
        executeUpdateAnswers(passageId, Array.from(mergedAnswers.entries()).map(([questionId, answer]) => ({
            questionId,
            answer: answer.answer,
        })));
    }, [executeUpdateAnswers, mergedAnswers, passageId]);
    const handleAnswerChange = (0, react_1.useCallback)((questionId, answer) => {
        setUpdatedAnswers((prev) => new Map(prev).set(questionId, answer));
    }, []);
    const submitEnabled = (0, react_1.useMemo)(() => {
        if (!questions) {
            return false;
        }
        if (mergedAnswers.size < questions.length) {
            return false;
        }
        for (const answer of mergedAnswers.values()) {
            if (!answer || answer.state === answer_1.AnswerResultState.Incorrect) {
                return false;
            }
        }
        return updateAnswersStatus !== use_lazy_promise_1.FetchStatus.Loading;
    }, [mergedAnswers, questions, updateAnswersStatus]);
    (0, react_1.useEffect)(() => {
        switch (updateAnswersStatus) {
            case use_lazy_promise_1.FetchStatus.Success:
                onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                break;
            case use_lazy_promise_1.FetchStatus.Error:
                alert.showAlert("Failed to update answers: " +
                    (updateAnswersError === null || updateAnswersError === void 0 ? void 0 : updateAnswersError.message) +
                    ". Please try again.", alert_context_1.AlertType.Error);
                break;
            default:
                break;
        }
    }, [updateAnswersStatus, onComplete, alert, updateAnswersError === null || updateAnswersError === void 0 ? void 0 : updateAnswersError.message]);
    return ((0, jsx_runtime_1.jsx)(quiz_renderer_1.QuizRenderer, { questions: questions.map((question) => question), userAnswers: mergedAnswers, onAnswerChanged: handleAnswerChange, initialIndex: initialIndex, skipEnabled: skipEnabled, actionComponent: (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "contained", onClick: handleSubmit, eventName: log_1.LogEventClickName.QuizSubmit, disabled: !submitEnabled, startIcon: updateAnswersStatus === use_lazy_promise_1.FetchStatus.Loading && ((0, jsx_runtime_1.jsx)(material_1.CircularProgress, { sx: { width: theme.spacing(2), height: theme.spacing(2) }, size: "small", color: "secondary" })), sx: { alignSelf: "flex-end", width: "fit-content" }, children: "Submit" }), sx: {
            padding: theme.spacing(6),
        } }));
});
QuizContainerInner.displayName = "QuizContainer";
exports.QuizContainer = (0, react_1.memo)(QuizContainerInner);
